// Focus pentru drawere / dialoguri modale (legat ca `@keydown.tab` pe wrapper-ul conținutului):
//  - `trapDrawerFocus` ține Tab / Shift+Tab în conținut;
//  - `focusFirstIn` mută focusul la prima țintă la deschidere;
//  - `rememberOpener` / `restoreOpener` întorc focusul la elementul care a deschis drawerul.
const FOCUSABLE = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const focusableNodes = (container) =>
  [...container.querySelectorAll(FOCUSABLE)].filter((node) => !node.disabled && node.getClientRects().length);

export const trapDrawerFocus = (event) => {
  const nodes = focusableNodes(event.currentTarget);
  const boundary = event.shiftKey ? nodes[0] : nodes.at(-1);
  if (document.activeElement === boundary) { event.preventDefault(); (event.shiftKey ? nodes.at(-1) : nodes[0])?.focus(); }
};

/** Prima țintă focusabilă din `container` (antetul drawerului), `false` dacă nu există niciuna. */
export const focusFirstIn = (container) => {
  const first = container ? focusableNodes(container)[0] : null;
  first?.focus();
  return Boolean(first);
};

/** Elementul care are focusul acum (apelat ÎNAINTE ca drawerul să preia focusul), sau `null` pe `body`. */
export const rememberOpener = () => {
  const active = typeof document === "undefined" ? null : document.activeElement;
  return active && active !== document.body ? active : null;
};

/** Întoarce focusul la `opener`, dacă mai este în pagină. */
export const restoreOpener = (opener) => {
  if (opener?.isConnected) opener.focus();
};
